import React, { useContext, useEffect } from 'react';
import styled from 'styled-components';
import Logo from '../../../assets/images/dashboardlogo.png';
import GenStyles from '../GenStyles';
import logoutFetch from '../../../assets/helpers/logoutFetch';
import { Context } from '../../../context';
import { useFacilitatorStore } from '../useFacilitatorStore';
import { Link, useLocation } from 'react-router-dom';
const S = {
  UserDetailButton: GenStyles.UserDetailButton,
  HeaderButton: styled.button`
    min-height: 42px;
    min-width: 120px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0.5rem 1rem;
    background: #378abd;
    border: #378abd solid 2px;
    border-radius: 5px;
    font-size: 1rem;
    font-weight: 600;
    line-height: 1.25;
    color: white;
    text-decoration: none;

    &:hover {
      background: white;
      color: #378abd;
    }
  `,
  Header: styled.header`
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: white;
    border-bottom: black solid 1px;
    padding: 1rem;
    gap: 1rem;
  `,
  LogoWrapper: styled.div`
    height: 50px;
  `,
  LogoLink: styled(Link)`
    display: block;
    height: 100%;
  `,
  Actions: styled.div`
    display: flex;
    align-items: center;
    gap: 0.75rem;
  `,

  AdminName: styled.span`
    font-size: 1.5rem;
  `,
  Image: styled.img`
    height: 100%;
    width: auto;
  `,
  Title: styled.span`
    margin: auto;
  `,
};

const AdminHeader = ({ children }) => {
  const context = useContext(Context);
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [location.pathname]);

  return (
    <S.Header>
      <S.LogoWrapper>
        <S.LogoLink to='/facilitator/home' aria-label='Go to home'>
          <S.Image src={Logo} alt='Logo' />
        </S.LogoLink>
      </S.LogoWrapper>
      <S.Actions>
        {children}
        <S.HeaderButton
          onClick={() => {
            logoutFetch();
            context.logout();
            useFacilitatorStore.getState().resetStore();
            localStorage.removeItem('facilitator-storage');
          }}
        >
          Log Out
        </S.HeaderButton>
      </S.Actions>
    </S.Header>
  );
};

export default AdminHeader;
